"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _TabsContext = _interopRequireDefault(require("./TabsContext"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TabPanel = (0, _react.forwardRef)((props, ref) => {
  const {
    prefix,
    className,
    title,
    children,
    text,
    tabPanelId,
    tabIndex,
    ...otherProps
  } = props;
  const classes = (0, _classnames.default)(`${prefix}tabs__panel`, className);
  const ctx = (0, _react.useContext)(_TabsContext.default);
  return _react.default.createElement("div", _extends({}, otherProps, {
    ref: ref,
    tabIndex: tabIndex,
    className: classes,
    id: tabPanelId,
    hidden: ctx.activeTab !== tabPanelId,
    onKeyDown: e => {
      (0, _utils.onTabPanelKeyDown)(e, ctx.activeTab, ctx.root);
    },
    role: "tabpanel"
  }), title && _react.default.createElement("h2", {
    className: "h4"
  }, title), text && _react.default.createElement("p", null, text), children && children);
});
TabPanel.defaultProps = {
  prefix: '',
  tabIndex: -1
};
var _default = TabPanel;
exports.default = _default;